export default {
    associationSettings: {
        digitalSignatureRequired: 'Digitale Unterschrift erforderlich',
        digitalSignatureRequiredDescription: 'Wenn diese Option aktiviert ist, müssen die diesem Verband untergeordneten Organisationen im Antragsbereich Formulare digital unterschreiben, sofern die digitale Unterschrift für das jeweilige Formular verfügbar ist.',
        digitalSignatureOptional: 'Digitale Unterschrift optional',
        digitalSignatureOptionalDescription: 'Wenn diese Option aktiviert ist, können die diesem Verband untergeordneten Organisationen im Antragsbereich Formulare digital unterschreiben, sofern die digitale Unterschrift für das jeweilige Formular verfügbar ist. Die digitale Unterschrift ist jedoch nicht zwingend erforderlich.',
        useBankAccount: 'Bankverbindung verwenden',
        useBankAccountDescription: 'Wenn diese Option aktiviert ist, müssen die diesem Verband untergeordneten Organisationen im Antragsbereich eine Bankverbindung angeben.',
        useSageExport: 'SAGE-Export verwenden',
        useSageExportDescription: 'Wenn diese Option aktiviert ist, werden für Vorgänge von Organisationen, die diesem Verband untergeordnet sind, keine SEPA-Lastschriften erstellt. Es werden stattdessen die Daten direkt nach SAGE exportiert.',
        sageExportSettings: 'SAGE-Export-Einstellungen',
        sageWebservice: 'SAGE Webservice',
        sageWebserviceDescription: 'z.B. http://85.93.80.6:8888',
        sageMandantId: 'SAGE Mandanten-ID',
        sageManagementOrganisationId: 'Verwaltungsorganisation',
        sageStackDescription: 'SAGE Stapelbeschreibungstext',
        sageStackDescriptionDescription: 'BST-T wenn leer',
        ecoreSenderIdentifier: 'eCore Absender-Kennung',
        ecoreSenderIdentifierDescription: 'Die eCore Absender-Kennung wird für den Datenaustausch mit eCore benötigt.',
        ecoreUser: 'eCore User',
        ecoreUserDescription: 'Der eCore Benutzer wird für den Datenaustausch mit eCore benötigt.',
        ecorePassword: 'eCore Passwort',
        ecorePasswordDescription: 'Das eCore Passwort wird für den Datenaustausch mit eCore benötigt.',

        ecoreUserData: 'eCore Nutzerdaten',
        websiteContent: 'Inhalte auf der Website',

        contentFrontend:'Inhalt im Menüpunkt "Info"',
        contentFrontendDescription: 'Dieser Inhalt wird im Antragsbereich unter dem Menüpunkt "Info" für alle angemeldeten Nutzer angezeigt',
        contentFrontendAlert:'Hinweis im Antragsbereich',
        contentFrontendAlertDescription: 'Dieser Hinweis wird oben im Antragsbereich angezeigt und ist für alle angemeldeten Nutzer sichtbar, die sich im Antragsbereich befinden.',
        contentDashboard:'Hinweis im Verwaltungsbereich (Dashboard)',
        contentDashboardDescription: 'Dieser Hinweis wird im Verwaltungsbereich oberhalb der Widgets auf dem Dashboard angezeigt.',
        contentPlaceholder: 'Inhalt',
    },

    educationalConcept: {
        educationalConcept: 'Bildungskonzept für {years}',
        newEducationalConcept: 'Neues Bildungskonzept',

        goal: 'Bildungsziel',
        page: 'Seitenzahl in Bildungskonzept',
        report: 'Sachbericht',
        expectedParticipantDays: 'Soll-Teilnahmetage',

        numberEducationalConceptGoals: 'Anzahl Bildungsziele',
        participantDays: 'Teilnahmetage',
        numberProcesses: 'Anzahl Vorgänge',

        useEducationalConcept: 'Bildungskonzept verwenden',
        useEducationalConceptDescription: 'Wenn diese Option aktiviert ist, verwenden die diesem Verband untergeordneten Organisationen im Landesjugendplan das Bildungskonzept.',
        educationalConceptDocument: 'Bildungskonzeptdokument',
        educationalConceptYears: 'Jahre, für die das Bildungskonzept gültig ist',

        addEducationalConcept: 'Bildungskonzept hinzufügen',
        deleteEducationalConcept: 'Bildungskonzept löschen',

        addEducationalConceptGoal: 'Bildungsziel hinzufügen',
        saveEducationalConceptGoalEdit: 'Bildungsziel speichern',
        deleteEducationalConceptGoal: 'Bildungsziel löschen',
        deleteEducationalConceptGoalText: 'Möchtest du das Bildungsziel wirklich löschen?',

        editEducationalConceptGoalSuccess: 'Bildungsziel wurde erfolgreich gespeichert',
        editEducationalConceptGoalError: 'Fehler beim Speichern des Bildungsziels',
        deleteEducationalConceptGoalSuccess: 'Bildungsziel wurde erfolgreich gelöscht',
        deleteEducationalConceptGoalError: 'Fehler beim Löschen des Bildungsziels',
    }
}